export enum TableDeletionActionType {
  ScheduleDeletion = "ScheduleDeletion",
  PendingDeletion = "PendingDeletion",
}

export interface ScheduleDeletionAction {
  type: TableDeletionActionType.ScheduleDeletion;
}

export interface PendingDeletionAction {
  type: TableDeletionActionType.PendingDeletion;
}

export type TableDeletionAction =
  ScheduleDeletionAction | PendingDeletionAction;

export interface TransferAction {
  type: "transfer";
  target_model_id: string;
}

export type TableAction = TableDeletionAction | TransferAction;

export function isScheduleDeletionAction(
  action: TableAction | undefined,
): action is ScheduleDeletionAction {
  return action?.type === TableDeletionActionType.ScheduleDeletion;
}

export function isPendingDeletionAction(
  action: TableAction | undefined,
): action is PendingDeletionAction {
  return action?.type === TableDeletionActionType.PendingDeletion;
}

export function isDeletionAction(
  action: TableAction | undefined,
): action is TableDeletionAction {
  return isScheduleDeletionAction(action) || isPendingDeletionAction(action);
}
